import React from "react";
import { detect } from "detect-browser";

export default class Outdated extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let browserInfo = "";
        const browser = detect();

        if (browser) {
            browserInfo = (
                <p>
                    <em>
                        {browser.name}
                        <br />
                        versie {browser.version}
                    </em>
                </p>
            );
        }

        return (
            <div className="content-container text-only">
                <div className="section-top">
                    <h1>Gebruik een recente browser en schakel over naar een nieuwe versie</h1>
                </div>

                <div className="content text-links">
                    <p>
                        Wil je veilig gebruikmaken van alle mogelijkheden van NIBHV Competent en alle digitale tools? Dan is het belangrijk dat je een recente browser
                        gebruikt. De browser die je nu gebruikt wordt niet langer ondersteund door de fabrikant ervan en daardoor loop je een hoger risico.
                    </p>

                    <p>Met een recente browser:</p>
                    <ul>
                        <li>is je privacy beter beschermd op internet</li>
                        <li>werkt je browser sneller</li>
                        <li>kan je alle mogelijkheden van NIBHV Competent gebruiken</li>
                        <li>worden websites beter weergegeven</li>
                    </ul>

                    <h2>Browser updaten op computer en laptop</h2>
                    <p>
                        Je kunt de browser updaten door naar de website van jouw browsermerk te gaan (bijvoorbeeld Google Chrome, Mozilla Firefox, Microsoft Edge etc.) en
                        daar te kiezen voor ‘downloaden’. Als er een oude versie van de browser aanwezig is hoef je die niet eerst te verwijderen. Dit gebeurt
                        automatisch.
                    </p>
                    <p>
                        Alle bladwijzers en opgeslagen wachtwoorden blijven bewaard. Bij het installeren van een andere, geheel nieuwe browser zal worden gevraagd of de
                        bladwijzers mogen worden geïmporteerd uit de oude browser. Als je gebruik maakt van een nieuwe browser heb je er verder geen omkijken naar:
                        updates worden automatisch geïnstalleerd.{" "}
                    </p>

                    {browserInfo}
                </div>
            </div>
        );
    }
}
